export const TableColumn = (props) => {
    return (<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" onClick={props.onClick}>
        <span>{props.value}</span>
  </td>);
}